<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-22 
-->
<template>
  <div>
    <Layout :key="activeDate">
      <Header>
        <home-header ref="header"></home-header>
      </Header>
      <Content>
        <keep-alive v-if="$route.meta.keepAlive">
          <router-view />
        </keep-alive>
        <router-view v-else />
      </Content>
      <Footer v-if="notFooter.indexOf($route.name) == -1">
        <home-footer ref="footer" :btnList="btnList"></home-footer>
        <fixed-btn ref="fixed-btn" :btnList="btnList" v-if="btnList.length"></fixed-btn>
      </Footer>
      <login-modal ref="login"></login-modal>
      <ticket-tip ref="ticket-tip"></ticket-tip>
    </Layout>
  </div>
</template>
<script>
import HomeHeader from '@/components/mobile/header.vue'
import HomeFooter from '@/components/mobile/footer.vue'
import FixedBtn from '@/components/mobile/fixedBtn.vue'
import LoginModal from '@/components/mobile/login.vue'
import TicketTip from '@/components/mobile/ticketTip.vue'
import { Aadvertisement, Ainsertrecords, AcreateJsapiSignature } from '@/service/app'
import { checkIfThereAreSendTickets } from '@/service/vbef'
import { mapState } from 'vuex'
import getJSSDK from 'js/share.js'
export default {
  metaInfo() {
    return {
      meta: [
        {
          name: 'viewport',
          content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no',
        },
      ],
    }
  },
  components: {
    HomeHeader,
    HomeFooter,
    FixedBtn,
    LoginModal,
    TicketTip,
  },
  provide() {
    return {
      debounce: this.debounce,
      reload: this.reload,
      login: this.login,
      clickBanner: this.clickBanner,
      globalInsertRecords: this.globalInsertRecords,
      wxShare: this.wxShare,
      checkIfThereAreSendTickets: this.checkIfThereAreSendTickets,
    }
  },
  created() {
    this.getBanner()
    if (this.user_key) {
      this.checkIfThereAreSendTickets()
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout)
    }
  },
  data() {
    return {
      notFooter: [
        'userInfo',
        'myTickets',
        'ticketDetail',
        'orderList',
        'signUp',
        'compReg',
        'contactUs',
        'addCompanions',
        'createShare',
        'companions'
      ],
      btnList: [],
      scrollTimeout: null, // 用于clearTimeout
    }
  },
  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      uuserId: (state) => state.uuserId,
      uuid: (state) => state.uuid,
      vbef_path: (state) => state.vbef_path,
      language: (state) => state.language,
      static_img_url: (state) => state.static_img_url,
    }),
  },
  methods: {
    debounce(fn, wait) {
      let timeout = null
      return () => {
        if (timeout !== null) {
          clearTimeout(timeout)
        }
        timeout = setTimeout(fn, wait)
      }
    },
    handleScroll() {
      if (this.notFooter.indexOf(this.$route.name) > -1) return
      // 滚动时设置isScroll为true
      this.$refs['fixed-btn'].isScroll = true

      // 清除之前的setTimeout（如果存在）
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout)
      }

      // 设置setTimeout，在停止滚动1秒后设置isScroll为false
      this.scrollTimeout = setTimeout(() => {
        this.$refs['fixed-btn'].isScroll = false
      }, 500)
    },
    reload(cb) {
      this.activeDate = moment().unix()
      this.$nextTick(() => {
        if (cb) {
          cb
        }
      })
    },
    login(cb = '') {
      this.$refs['login'].beginLogin(cb)
    },
    async getBanner() {
      let res = await Aadvertisement({
        appAdPositionIds: this.language == 'zh' ? [68, 69, 70, 71] : [77, 79, 80, 81],
      })
      if (res.code == 0) {
        this.$set(this.$data, 'btnList', res.data)
      }
    },
    clickBanner(item, kw) {
      this.globalInsertRecords({
        contentId: item.appAdScheduleId,
        contentType: '45',
        viewType: 1,
        keyword: kw,
      })
      if (item.jumpType == 1) {
        const cb = () => {
          window.location.href = item.jumpOrientation.pointUrl
        }
        const urlsToCheck = [
          'vbdata.cn/signUp',
          'vbdata.cn/myTickets',
          'vbdata.cn/orderList',
          'vbdata.cn/userInfo',
          'vbdata.cn/ticketDetail',
        ]
        const pointUrl = item.jumpOrientation.pointUrl

        if (!this.user_key) {
          for (const url of urlsToCheck) {
            if (pointUrl.includes(url)) {
              this.login(cb)
              return
            }
          }
        }
        cb()
      }
    },
    async globalInsertRecords(item, cb) {
      let createTime = moment().format('YYYY-MM-DD HH:mm:ss')
      let params_arr = [
        {
          ...item,
          ...{
            createTime: createTime,
            xuserid: this.uuserId,
            imei: this.uuid,
            enterType: this.$route.meta.enter_type,
            loginPlatform: 7,
          },
        },
      ]
      let res = await Ainsertrecords({
        appAccessRecords: params_arr,
      })
      if (cb) cb()
    },
    /**
     * @params { title, desc, linkurl, img }
     */
    async wxShare(params) {
      const currentUrl = this.vbef_path + this.$route.fullPath
      params.desc = '2026年5月19日-21日 | 上海闵行白金汉爵大酒店，诚邀您参与'
      if (this.$route.query.language == 'en') {
        params.desc = 'May 19-21, 2026 | Platinum Hanjue Hotel,Minhang,Shanghai.We sincerely invite you to attend'
        params.linkurl = `${params.linkurl}?language=en`
      }
      params.img = params.img || this.static_img_url + 'pic/share-img.jpg'
      console.log(params)
      let res = await AcreateJsapiSignature(
        {
          url: currentUrl,
        },
        (error) => {
          this.$notify(this.language == 'zh' ? '请求错误!' : 'Request error!')
        }
      )
      if (res.code == 0) {
        getJSSDK(res.data, params)
      }
    },
    async checkIfThereAreSendTickets() {
      let res = await checkIfThereAreSendTickets({})
      if (res.code == 0 && res.data.count > 0) {
        this.$refs['ticket-tip'].modelIndex = true
        this.$refs['ticket-tip'].count = res.data.count
      }
    }
  },
}
</script>
<style lang='stylus'>
html
  font-size 50px !important
.ivu-layout
  background #FFFFFF
  &-header
    height 1.22rem
    line-height 1
    background-color #FFFFFF
    padding 0
    position fixed
    width 100%
    z-index 1001
    box-shadow 0px 1px 4px 0px rgba(14, 15, 20, 0.2)
  &-content
    padding-top 1.22rem
    min-height 100vh
  &-footer
    background #FAFAFA
    padding 0
.loading-warpper
  display flex
  justify-content center
  margin-top 0.2rem
.list-over
  margin-top 0.2rem
  text-align center
  color #999
.nothing-warp
  padding 0.4rem
  img
    width 3rem
    height 1.87rem
  .nothing-text
    margin-top 0.2rem
    font-size 0.28rem
  .btn
    margin-top 0.2rem
    width 2.18rem
    height 0.72rem
    font-size 0.28rem
    border-radius 0.1rem
    line-height 0.72rem
    &:active
      background-color #FF4800
      border-color #FF4800
</style>